import gql from 'graphql-tag';
import React from 'react';

import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import getTestProps from 'test/lib/cypress/getTestProps';

import {
  ReviewLifecycleNamesQuery,
  ReviewLifecycleNamesQueryVariables,
} from './__generated/ReviewLifecycleNamesQuery';

interface ReviewLifecycleNamesLabelProps {
  lifecycleIds: Array<string>;
}

export const REVIEW_LIFECYCLE_NAMES_QUERY = gql`
  query ReviewLifecycleNamesQuery($lifecycleIds: [StrictString!]!) @skipAudit @engComponent(name: NOTEBOOK) {
    reviewLifecycles(ids: $lifecycleIds) {
      ... on ReviewLifecycleNode {
        id
        currentVersion {
          id
          name
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export default function ReviewLifecycleNamesLabel({
  lifecycleIds,
}: ReviewLifecycleNamesLabelProps): JSX.Element | null {
  const result = useBenchlingQuery<ReviewLifecycleNamesQuery, ReviewLifecycleNamesQueryVariables>(
    REVIEW_LIFECYCLE_NAMES_QUERY,
    {
      variables: {lifecycleIds},
      fetchPolicy: 'cache-and-network',
    }
  );

  if (result.type === QueryResultType.PENDING || result.type === QueryResultType.ERROR) {
    return null;
  }

  const names: Array<string> = [];
  for (const reviewLifecycle of result.data.reviewLifecycles) {
    if (isInaccessible(reviewLifecycle)) {
      continue;
    }
    names.push(reviewLifecycle.currentVersion.name);
  }
  return (
    <span {...getTestProps({component: 'ReviewLifecycleNamesLabel', element: 'root'})}>
      {names.join(', ')}
    </span>
  );
}
